import React from "react";
import ComingSoonNotice from "./ComingSoonNotice";

// Root-level safety net: without this, any uncaught render error anywhere in the
// tree (including inside AuthProvider) blanks the whole app with no recovery UI.
export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ComingSoonNotice
          icon="⚠️"
          title="Something went wrong"
          message="An unexpected error occurred. Please reload the page."
          actionLabel="Reload"
          onAction={() => window.location.reload()}
        />
      );
    }
    return this.props.children;
  }
}
